<template>
  <div class="sm:flex sm:items-center">
    <div class="sm:flex-auto"></div>
    <span v-if="this.anyProductSelected" class="relative z-0 inline-flex shadow-xs rounded-md space-x-3">
      <button
        type="button"
        @click="this.uploadProductsToPlatform"
        class="relative inline-flex items-center px-4 py-2 border border-transparent shadow-xs text-sm font-medium text-button-font-primary bg-primary transition duration-300 transform hover:scale-105 rounded-lg focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-primary"
      >
        {{ $t("Upload to platform") }}
      </button>
      <button
        type="button"
        @click="this.removeProductsFromPlatform"
        class="-ml-px relative inline-flex items-center px-4 py-2 border border-transparent shadow-xs text-sm font-medium text-button-font-primary bg-primary transition duration-300 transform hover:scale-105 rounded-lg focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-primary"
      >
        {{ $t("Remove from platform") }}
      </button>
    </span>
  </div>
</template>

<script>
export default {
  props: ["selectedProducts"],
  computed: {
    anyProductSelected() {
      return this.selectedProducts.length > 0;
    },
  },
  methods: {
    uploadProductsToPlatform() {
      this.$emit("upload", this.selectedProducts);
    },
    removeProductsFromPlatform() {
      this.$emit("remove", this.selectedProducts);
    },
  },
};
</script>
